/* eslint-disable no-unreachable */
<!-- This component displays the terms and conditions PDFs for Networks and Events with custom terms. -->
<!--  -->
<!-- There are 3 rendering options currently: -->
<!-- 1. Object Embed - Doesn't work on mobile at this time. -->
<!-- 2. Google Doc Viewer - Works well, though sometimes fails to render the PDF, and it's up to Google whether to continue support or not. -->
<!-- 3. PDFJS - Works well, except throws CORS issue with MS Edge. -->
<!--  -->
<!-- NOTE: For download to work with S3 Hosted files, you need to add some metadata to the file(s): -->
<!-- 1. Content-Type: application/pdf -->
<!-- 2. Content-disposition: attachement -->
<template>
  <div>
    <!-- OBJECT EMBED - NOT SUITABLE FOR MOBILE -->
    <object v-if="_renderer === 'object'" class="amazeTermsViewer" name="terms" v-bind:data="src" type="application/pdf" v-bind:width="_width" v-bind:height="_height">
      <parm name="view" value="FitW" />
      <embed v-bind:src="terms" type="application/pdf">
          <iframe :src="src" v-bind:width="_width" v-bind:height="_height"></iframe>
      </embed>
    </object>

    <!-- GOOGLE DOC VIEWER IFRAME -->
    <iframe v-if="_renderer === 'google'" class="amazeTermsViewer" :src="googleEmbedUrl" v-bind:width="_width" v-bind:height="_height" embedded="true" frameborder="0"></iframe>

     <!-- PDFJS VIEWER IFRAME -->
    <iframe v-if="_renderer === 'default'" class="amazeTermsViewer" :src="pdfjsEmbedUrl" v-bind:width="_width" v-bind:height="_height" embedded="true" frameborder="0"></iframe>

    <div class="amazeTermsViewerDownloadWrapper">
      <v-btn @click="downloadTerms" class="mx-0" color="secondary"><v-icon>cloud_download</v-icon>&nbsp; Download PDF</v-btn>
      <a class="hidden" ref="termsDownload" download="terms.pdf" target="_blank" :href="src"><v-icon>cloud_download</v-icon>  Download PDF</a>
    </div>
  </div>
</template>
<style lang="scss" scoped>

.amazeTermsViewer {
  overflow-y: scroll;
  overflow: scroll;
  margin-bottom: 10px;
  border: 1px solid #707070;
}
</style>
<script>
export default {
  props: ["src", "renderer", "fallback", "height", "width"],
  computed: {
    _height() {
      return this.height || "400px";
    },
    _width() {
      return this.width || "100%";
    },
    _fallback () {
      // Fallback renderer (in case the primary renderer fails).
      // Currently this is only used for MS Edge support because
      // as is typical of MS and web tech, Edge doesn't work like
      // every other browser tested.
      return this.fallback || 'google';
    },
    _renderer() {
      switch (this.renderer) {
        case 'object':
          return 'object';
          // eslint-disable-next-line no-unreachable
          break;
        case 'google':
          return 'google';
          // eslint-disable-next-line no-unreachable
          break;
        default:
          return 'default';
          // eslint-disable-next-line no-unreachable
          break;
      }
    },
    pdfjsEmbedUrl() {
      return "/pdfjs/web/viewer.html?file=" + this.src;
    },
    googleEmbedUrl() {
      return "https://docs.google.com/viewer?url=" + this.src + "&embedded=true";
    }
  },
  methods: {
    downloadTerms: function() {
      this.$refs.termsDownload.click();
    }
  },
  mounted() {
    // This is a hacky workaround for MS Edge (which is a bit of an edge case since there's currently
    // only very limited use of this browser). First we check to see if the browser can request the
    // source document. If there's an error (i.e. CORS error that happens with Edge), we switch to
    // whatever fallback renderer is specified (ex: default fallback is to use Google).
    this.$http.get(this.src).then((response) => {
    }, error => {
      this._renderer = this._fallback;
    });
  }
};
</script>
